export default function clearEmptyValues<T = Record<string | number | symbol, unknown>>(value: T): Partial<T> {
  const newValue: Partial<T> = {};

  Object.keys(value).forEach(key => {
    const k = key as keyof T;

    if (value[k] !== null && value[k] !== undefined && value[k] !== '') {
      newValue[k] = value[k];
    }
  });

  return newValue;
}
